import { Platform } from 'quasar';
import { LOCALSTORAGE } from 'src/composables/const';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';

import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */
export default function () {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  // Handle navigation duplicate errors
  /* eslint-disable */
  const originalPush = Router.push;
  Router.push = function push(location) {
    return (originalPush.call(this, location) as unknown as Promise<any>).catch(
      (err) => err
    );
  };
  /* eslint-enable */

  Router.beforeEach((to, from, next) => {
    // Handle mobile onboarding
    if (Platform.is.capacitor) {
      const didOpen = localStorage.getItem(LOCALSTORAGE.ONBOARDING);
      if (!didOpen && to.name !== 'Onboarding') {
        next('/onboarding');
        return;
      }
    }

    // Handle 404
    if (!to.matched.length) {
      next('/404');
    } else {
      next();
    }
  });

  return Router;
}
